var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen"},[(_vm.isShow)?_c('FullView',{attrs:{"details":_vm.detailsInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }